module.exports = __webpack_public_path__ + "static/media/335.aec2cfa7.svg";